export default "__VITE_ASSET__Bs_WTuT2__"